import { AccordionForm, AccordionFormPanelProps as Props } from '@react-admin/ra-form-layout';
import { required, TextInput } from 'react-admin';
import { ReactElement } from 'react';
import JsonApiHasOneReferenceInput from '../../../../Components/JsonApiHasOneReferenceInput';
import { BidResource } from '../../../../Entities/Bid';
import { CurrencyAmountInput } from '../../../../Components/CurrencyAmount/CurrencyAmountInput';
import { BID_TYPE } from '../../utils';
import { Grid2 as Grid } from '@mui/material';
import { useWatch } from 'react-hook-form';
import ImageUrlInput from '../../../../Components/ImageUrlInput';

export default function OfferDetailsSection(props: Omit<Props, 'children'>): ReactElement {
  const bidType = useWatch({ name: 'attributes.bid_type' });
  return (
    <AccordionForm.Panel {...props}>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <TextInput label="Name" source="attributes.name" validate={[required()]} />
          <TextInput label="Description" source="attributes.description" multiline />
          <ImageUrlInput label="Image" source="attributes.image_url" />
        </Grid>
        <Grid size={{ xs: 12, lg: 6 }}>
          <JsonApiHasOneReferenceInput<BidResource, 'merchant'>
            filterFields={['merchant_name']}
            isRequired
            label="Merchant"
            nullable={false}
            optionText="attributes.merchant_name"
            reference="merchants"
            source="relationships.merchant"
            validate={[required()]}
          />
          <TextInput
            isRequired={bidType === BID_TYPE.PRODUCT}
            label="Site ID"
            source="attributes.site_id"
          />
          <TextInput label="Offer URL" source="attributes.url" validate={[required()]} />
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, lg: 6 }}>
              <CurrencyAmountInput
                label="Offer Price"
                source="attributes.offer_price"
                validate={[required()]}
              />
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <CurrencyAmountInput label="Retail Price" source="attributes.retail_price" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </AccordionForm.Panel>
  );
}
